import { useCallback } from "react";
import useU2000AxiosAuthenticated from "../u2000Core/axios/U2000UseAxiosAuthenticated";
import { doSubmitForApproval, type U3129Timesheet } from "./U3129Service";

/**
 * Appel réseau dédié : ne pas invoquer `doSubmitForApproval` depuis les composants (pattern handlers u2000).
 */
export function useU3129SubmitForApprovalHandlers() {
  const axios = useU2000AxiosAuthenticated();

  const submitForApproval = useCallback(
    async (timesheetId: string, version: number): Promise<U3129Timesheet> => {
      const res = await doSubmitForApproval(axios, timesheetId, { id: timesheetId, version });
      const raw = res.data?.result ?? res.data;
      return raw as U3129Timesheet;
    },
    [axios],
  );

  return { submitForApproval };
}
